import { PAGE_DEFAULT, ROW_DEFAULT } from "constants/global";

export const EMPTY_DATA_SEARCH_MAILING_HISTORY = {
    text_search: "",
    row: ROW_DEFAULT,
    page: PAGE_DEFAULT,
}
